import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../components/CTAButton';

export function SoftPaywallScreen() {
  const nav = useNavigate();
  return (
    <div className="lume-bg min-h-svh flex flex-col">
      <div className="h-0.5 bg-gradient-to-r from-accent to-accent-dim" />

      <div className="flex-1 overflow-y-auto px-6 pt-11">
        <h1 className="text-headline text-text">Photo captured.</h1>
        <p className="text-title text-text-secondary mt-1.5">
          Here's what your plan unlocks once we've analysed your skin.
        </p>

        <div className="mt-9 bg-surface rounded-card divide-y divide-surface-raised">
          {[
            ['📋', 'Personalised AM and PM routine'],
            ['🧪', 'Ingredient guide matched to your skin'],
            ['📷', 'A locked-in plan you can come back to anytime'],
            ['🔐', 'Private — analysis is end-to-end secured'],
          ].map(([icon, text]) => (
            <div key={text} className="flex items-center gap-3.5 px-4 py-4">
              <span className="text-accent text-base w-5 text-center">{icon}</span>
              <span className="text-body text-text-secondary">{text}</span>
            </div>
          ))}
        </div>

        <div className="mt-8 lume-card-bordered">
          <p className="lume-eyebrow text-accent">PLAN VALUE</p>
          <div className="flex items-baseline gap-1.5 mt-2">
            <span className="font-extrabold text-text" style={{ fontSize: 36 }}>
              $11.99
            </span>
            <span className="text-body text-text-secondary">one time</span>
          </div>
          <p className="text-caption text-text-tertiary mt-1">
            No subscription. No auto-renew. First-scan offer applies at checkout.
          </p>
        </div>

        <div className="h-8" />
      </div>

      <div
        className="bg-bg/95 backdrop-blur px-6 pt-4"
        style={{ paddingBottom: 'max(3rem, env(safe-area-inset-bottom))' }}
      >
        <CTAButton label="See My Results" onClick={() => nav('/loading')} />
        <p className="text-caption text-text-tertiary text-center mt-3">
          You'll see your skin age and breakdown before deciding.
        </p>
      </div>
    </div>
  );
}
